// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCollapse = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M21.385 4.414l-5.392 5.392 3.978.265-1.768 1.768-5.303-.354-.354-5.303 1.768-1.768.265 3.978L19.97 3zM3 19.97l5.392-5.391-3.978-.265 1.768-1.768 5.303.354.354 5.303-1.768 1.768-.265-3.978-5.392 5.392z" />
  );
export default SvgIconCollapse;
